module.exports = __webpack_public_path__ + "assets/images/edit-modal.4185b5ef625e708f51d9175ba24653a3.svg";